import { Injectable } from "@angular/core";

import Block from "quill/blots/block";

import { OnChangeFn, OnChangeFnMutation } from "../../models";


@Injectable()
export class RichTextEditorChangeService {

    public getChange(onChange: OnChangeFn, mutations: OnChangeFnMutation[]): OnChangeFn {
        // Return empty on-change function if it is not defined.
        if (!onChange) return _ => null;

        // Return original on-change function if mutations are empty.
        if (!mutations?.length) return onChange;

        return mutations
            // Remove null mutations.
            .filter((mutation: OnChangeFnMutation): boolean => !!mutation)

            // Apply each mutation to original change function.
            .reduce((change: OnChangeFn, mutation: OnChangeFnMutation): OnChangeFn => mutation(change), onChange);
    }

    public makeNewlinesAware(): OnChangeFnMutation {
        return (onChange: OnChangeFn): OnChangeFn => {
            // Html tag quill is using for blocks.
            const block: string = Block.tagName as string;

            // Pattern to match empty blocks in the output.
            const pattern: string = `<${block}></${block}>`;

            // Replacement to substitute them by blocks with soft line-breaks.
            const replacement: string = `<${block}><br/></${block}>`;

            const regex = new RegExp(pattern, "gi");

            // Substitute empty blocks by blocks with soft line-breaks in the output.
            return (value: string): void => onChange?.(value?.replace(regex, replacement));
        }
    }
}